module.exports = __webpack_public_path__ + "img/hero1.6db6a791.webp";